<script setup lang="ts">
import { ArrowDown, ArrowUpRight, Check, Leaf } from "lucide-vue-next";
import { onBeforeUnmount, onMounted } from "vue";
import "@/assets/styles/home.css";
import AboutView from "@/views/AboutView.vue";
import ReferencesView from "@/views/ReferencesView.vue";
import ReviewView from "@/views/ReviewView.vue";
import ServiceView from "@/views/ServiceView.vue";
import ContactView from "@/views/ContactView.vue";
import FooterImpressum from "@/components/FooterImpressum.vue";
import SidebarComponent from "@/components/SidebarComponent.vue";

let observer: IntersectionObserver | undefined;

onMounted(() => {
  observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        observer?.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  document.querySelectorAll(".reveal").forEach((el) => observer?.observe(el));
});

onBeforeUnmount(() => observer?.disconnect());
</script>

<template>
  <div class="home" id="home">
    <SidebarComponent />

    <main>
      <section class="hero">
        <div class="hero-ambient hero-ambient-one" />
        <div class="hero-ambient hero-ambient-two" />
        <div class="hero-content">
          <div class="hero-kicker hero-enter">
            <Leaf :size="16" />
            GaLaBau für Gewerbe, Kommunen & Privatkunden
          </div>
          <h1 class="hero-enter hero-enter-delay">
            Wir gestalten <em>Freiraum.</em><br />Und Werte, die bleiben.
          </h1>
          <p class="hero-lead hero-enter hero-enter-delay-two">
            Von der ersten Idee bis zur dauerhaften Pflege: Wir entwickeln Außenanlagen, die ästhetisch überzeugen, wirtschaftlich funktionieren und jeden Tag gerne genutzt werden.
          </p>
          <div class="hero-actions hero-enter hero-enter-delay-two">
            <a href="#contact" class="button button-primary">Projekt besprechen <ArrowUpRight :size="19" /></a>
            <a href="#references" class="button button-ghost">Arbeiten ansehen <ArrowDown :size="19" /></a>
          </div>
        </div>

        <div class="hero-proof hero-enter hero-enter-delay-two">
          <div class="proof-item"><strong>15+</strong><span>Jahre Erfahrung</span></div>
          <div class="proof-item"><strong>240</strong><span>realisierte Projekte</span></div>
          <div class="proof-item"><strong>1</strong><span>Team, das mitdenkt</span></div>
        </div>

        <div class="hero-note">
          <Check :size="16" /> Persönlich geplant · fachgerecht gebaut · verlässlich gepflegt
        </div>
      </section>

      <AboutView />
      <ServiceView />
      <ReferencesView />
      <ReviewView />
      <ContactView />
    </main>

    <FooterImpressum />
  </div>
</template>
